export const API_ROUTES = {
	signIn: 'auth/sign-in',
	signUp: 'auth/sign-up',
	refresh: 'auth/refresh',
	sendOTP: 'verification/send-otp',
	resendOTP: 'verification/resend-otp',
	verifyEmail: 'verification/verify-email',
	usersMe: 'users/me',
	subscriptions: 'subscriptions/plans',
	createSubscription: 'users/subscriptions/create',
	currentSubscription: 'users/subscriptions/current',
	cancelSubscription: 'users/subscriptions/cancel',
	promocodeValidate: 'promocodes/validate',
	usersTimezone: 'users/settings/timezone',
};
